import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preset", "customFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isCustom = this.presetTarget.value === 'custom'
    this.customFieldsTargets.forEach(field => {
      field.style.display = isCustom ? 'block' : 'none'
    })
  }
}
